var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7480_35791",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7480_35791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5623 21.9894L6.45709 22C4.01394 22.0022 2.01333 20.0055 2.01055 17.5623L2 6.45709C1.99778 4.01394 3.9945 2.01333 6.43766 2.01055L17.5429 2C19.9861 1.99778 21.9867 3.9945 21.9894 6.43766L22 17.5429C22.0028 19.9866 20.0055 21.9872 17.5623 21.9894Z",
    fill: "url(#paint0_radial_7480_35791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5623 21.9894L6.45709 22C4.01394 22.0022 2.01333 20.0055 2.01055 17.5623L2 6.45709C1.99778 4.01394 3.9945 2.01333 6.43766 2.01055L17.5429 2C19.9861 1.99778 21.9867 3.9945 21.9895 6.43766L22 17.5429C22.0028 19.9866 20.0055 21.9872 17.5623 21.9894Z",
    fill: "url(#paint1_radial_7480_35791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0021 15.887C9.85931 15.887 8.11523 14.1434 8.11523 12.0001C8.11523 9.85681 9.85931 8.11328 12.0021 8.11328C14.1448 8.11328 15.8889 9.85681 15.8889 12.0001C15.8889 14.1434 14.1448 15.887 12.0021 15.887ZM12.0021 9.22381C10.4712 9.22381 9.22576 10.4693 9.22576 12.0001C9.22576 13.531 10.4712 14.7764 12.0021 14.7764C13.5329 14.7764 14.7784 13.531 14.7784 12.0001C14.7784 10.4693 13.5329 9.22381 12.0021 9.22381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1649 8.66823C16.6249 8.66823 16.9978 8.29533 16.9978 7.83534C16.9978 7.37534 16.6249 7.00244 16.1649 7.00244C15.7049 7.00244 15.332 7.37534 15.332 7.83534C15.332 8.29533 15.7049 8.66823 16.1649 8.66823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3332 19.2186H8.67004C6.52728 19.2186 4.7832 17.475 4.7832 15.3317V8.66857C4.7832 6.52526 6.52728 4.78174 8.67004 4.78174H15.3332C17.4759 4.78174 19.22 6.52526 19.22 8.66857V15.3317C19.22 17.475 17.4759 19.2186 15.3332 19.2186ZM8.67004 5.89226C7.13918 5.89226 5.89373 7.13772 5.89373 8.66857V15.3317C5.89373 16.8626 7.13918 18.108 8.67004 18.108H15.3332C16.864 18.108 18.1095 16.8626 18.1095 15.3317V8.66857C18.1095 7.13772 16.864 5.89226 15.3332 5.89226H8.67004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7480_35791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.43497 22.0144) scale(24.9307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7480_35791",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.2183 1.7503) scale(16.554 11.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.806f3049bd5a80edb9b63502b475bed2.svg";
export { ForwardRef as ReactComponent };